import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IContact, IContactExists, IContactInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ContactApiService {
  abstract getContact(id?: string | '', resetCache?:boolean ): Observable<IContact>;
  abstract getContacts(): Observable<IContact[]>;

  abstract updateContact(contact: IContactInput): Observable<IContact>;

  abstract saveContactUnlisted(contact: IContactInput): Observable<IContact>;
  abstract checkContractorLicense(licenseNumber: string): Observable<IContact>;
  abstract CheckLDPLicense(licenseNumber?: string | ''): Observable<IContact>;
  abstract  getContactExists(email: string): Observable<boolean>;
  abstract GetLdpByIdQuery(
    id: string,
    resetCache: boolean
  ): Observable<IContact> ;
  abstract saveLdpUnlisted(contact: IContactInput): Observable<IContact>;
  abstract CheckLdpContactExists(email: string) : Observable<IContactExists>;
}
